// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"26":"858543e0","84":"bc548673","542":"964e90b3","781":"9b5cb5b6"}[chunkId] + ".chunk.js";
};